module.exports = __webpack_public_path__ + "static/pic02-d96a908a314085f047fe120cbd1557d7.jpg";